import ContactUs from '../../assets/svg/ContactUs.svg';
import ContactUsSelected from '../../assets/svg/ContactUs_selected.svg';
import ContractIcon from '../../assets/svg/contract.svg';
import ContractIconSelected from '../../assets/svg/contract_selected.svg';
import DescriptionIcon from '../../assets/svg/description.svg';
import DescriptionIconSelected from '../../assets/svg/description_selected.svg';
import Faq from '../../assets/svg/FAQ.svg';
import FAQSelected from '../../assets/svg/FAQselected.svg';
import HomeIcon from '../../assets/svg/home.svg';
import HomeIconSelected from '../../assets/svg/home_selected.svg';
import Complaint from '../../assets/svg/raise_complaint.svg';
import ComplaintSelected from '../../assets/svg/raise_complaint_selected.svg';
import Signout from '../../assets/svg/Sign-out.svg';
import DocumentDownload from '../../assets/svg/startIcon.svg';
import DocumentDownloadSelected from '../../assets/svg/startIconSelected.svg';
import Tc from '../../assets/svg/TnC.svg';
import TCSelected from '../../assets/svg/TnC_selected.svg';
import TransactionIcon from '../../assets/svg/Transactions.svg';
import TransactionIconSelected from '../../assets/svg/Transactions_selected.svg';
import {useMenuVisibility} from '../../hooks/useMenuVisibility';
import {MENU_OPTIONS_UNLEASH_KEY} from '../../utils/constant';
import {Navigate} from '../../utils/util';

import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  Paper,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './Sidebar.css';

import sidebarJson from './Sidebar.json';

const Sidebar = ({
  selectedMenu,
  setVisible,
  noContract,
  contractNumberError,
  countryCode,
  oktaCountryCode,
  noScheduleData,
  contractCounts,
  pastContractsCounts,
}) => {
  const {t} = useTranslation();
  const menuJson = sidebarJson[countryCode ?? oktaCountryCode];
  const {flag: sidebarFlag, isItemVisible} = useMenuVisibility(
    MENU_OPTIONS_UNLEASH_KEY
  );

  const mapping = {
    ContactUsSelected: (
      <img src={ContactUsSelected} alt="Contact Us Selected" />
    ),
    ContactUs: <img src={ContactUs} alt="Contact Us" />,
    TCSelected: <img src={TCSelected} alt="Terms and Conditions Selected" />,
    TC: <img src={Tc} alt="Terms and Conditions" />,
    ComplaintSelected: <img src={ComplaintSelected} alt="Complaint Selected" />,
    Complaint: <img src={Complaint} alt="Complaint" />,
    Signout: <img src={Signout} alt="Sign Out" />,
    DocumentDownload: <img src={DocumentDownload} alt="Document Download" />,
    DocumentDownloadSelected: (
      <img src={DocumentDownloadSelected} alt="Document Download Selected" />
    ),
    FAQ: <img src={Faq} alt="FAQ" />,
    FAQSelected: <img src={FAQSelected} alt="FAQ Selected" />,
  };

  return (
    <Box maxWidth="600px" className="box-sidebar-landing">
      <Paper className="sidebar-paper" key="sidebar-paper-1">
        <List aria-label="Sidebar-1" disablePadding>
          {noScheduleData || (sidebarFlag && !isItemVisible('home')) ? null : (
            <ListItemButton
              selected={selectedMenu === 'home'}
              onClick={() => {
                Navigate('home');
              }}
              key="home"
            >
              <ListItemIcon>
                {selectedMenu === 'home' ? (
                  <img src={HomeIconSelected} alt="Home Selected" />
                ) : (
                  <img src={HomeIcon} alt="Home" />
                )}
              </ListItemIcon>
              <span
                className={`list-item ${selectedMenu === 'home' && 'selected'}`}
              >
                {t('HOME')}
              </span>
            </ListItemButton>
          )}

          {noContract ? null : (
            <>
              {!sidebarFlag || isItemVisible('paymentSchedule') ? (
                <ListItemButton
                  selected={selectedMenu === 'paymentSchedule'}
                  onClick={() => Navigate('paymentSchedule')}
                  key="paymentSchedule"
                >
                  <ListItemIcon>
                    {selectedMenu === 'paymentSchedule' ? (
                      <img
                        src={TransactionIconSelected}
                        alt="Payment Schedule Selected"
                      />
                    ) : (
                      <img src={TransactionIcon} alt="Payment Schedule" />
                    )}
                  </ListItemIcon>
                  <span
                    className={`list-item ${
                      selectedMenu === 'paymentSchedule' && 'selected'
                    }`}
                  >
                    {t('PAYMENT_SCHEDULE')}
                  </span>
                </ListItemButton>
              ) : null}
              {!sidebarFlag || isItemVisible('contractDetails') ? (
                <ListItemButton
                  selected={
                    selectedMenu === 'contractDetails' ||
                    selectedMenu === 'contractDetailsOverview'
                  }
                  onClick={() =>
                    Navigate(
                      contractCounts > 1
                        ? 'contractDetailsOverview'
                        : 'contractDetails'
                    )
                  }
                  key="contractDetails"
                >
                  <ListItemIcon>
                    {selectedMenu === 'contractDetails' ||
                    selectedMenu === 'contractDetailsOverview' ? (
                      <img
                        src={DescriptionIconSelected}
                        alt="Contract Details Selected"
                      />
                    ) : (
                      <img src={DescriptionIcon} alt="Contract Details" />
                    )}
                  </ListItemIcon>
                  <span
                    className={`list-item ${
                      selectedMenu === 'contractDetails' ||
                      selectedMenu === 'contractDetailsOverview'
                        ? 'selected'
                        : ''
                    }`}
                  >
                    {t('CONTRACT_DETAILS')}
                  </span>
                </ListItemButton>
              ) : null}

              {!sidebarFlag || isItemVisible('serviceRequest') ? (
                <ListItemButton
                  selected={selectedMenu === 'serviceRequest'}
                  onClick={() => {
                    Navigate('serviceRequest');
                  }}
                  key="serviceRequest"
                >
                  <ListItemIcon>
                    {selectedMenu === 'serviceRequest' ? (
                      <img
                        src={ContractIconSelected}
                        alt="Service Request Selected"
                      />
                    ) : (
                      <img src={ContractIcon} alt="Service Request" />
                    )}
                  </ListItemIcon>
                  <span
                    className={`list-item ${
                      selectedMenu === 'serviceRequest' && 'selected'
                    }`}
                  >
                    {t('SERVICE_REQUEST')}
                  </span>
                </ListItemButton>
              ) : null}
            </>
          )}
          {(noContract && pastContractsCounts <= 0) ||
          (sidebarFlag && !isItemVisible('download')) ? null : (
            <ListItemButton
              selected={selectedMenu === 'download'}
              onClick={() => {
                Navigate('download');
              }}
              onKeyUp={() => {}}
              key="download"
            >
              <ListItemIcon>
                {selectedMenu === 'download' ? (
                  <img src={DocumentDownloadSelected} alt="download Selected" />
                ) : (
                  <img src={DocumentDownload} alt="download" />
                )}
              </ListItemIcon>
              <span
                className={`list-item ${
                  selectedMenu === 'download' && 'selected'
                }`}
              >
                {t('DOWNLOAD')}
              </span>
            </ListItemButton>
          )}
        </List>
      </Paper>
      <Paper className="sidebar-paper" key="sidebar-paper-2">
        <List aria-label="Sidebar-1" disablePadding>
          {menuJson?.sidebar?.map((item) => {
            const featureVisible = sidebarFlag
              ? isItemVisible(item.item)
              : true;
            const hideForContractError =
              item.isVisibleContractError && contractNumberError;
            const hideDownloadForNoContract =
              item.item === 'download' &&
              noContract &&
              pastContractsCounts <= 0;

            if (
              !featureVisible ||
              hideForContractError ||
              hideDownloadForNoContract
            ) {
              return null;
            }

            return (
              <ListItemButton
                selected={selectedMenu === item.item}
                onClick={() => {
                  Navigate(item.item);
                }}
                id={item.item}
                key={item.item}
              >
                <ListItemIcon>
                  {selectedMenu === item.item
                    ? mapping[item.selectedIcon]
                    : mapping[item.icon]}
                </ListItemIcon>
                <span
                  className={`list-item ${
                    selectedMenu === item.item && 'selected'
                  }`}
                >
                  {t(item.label)}
                </span>
              </ListItemButton>
            );
          })}
          <ListItemButton
            className={`${selectedMenu === 'signout' && 'selected'}`}
            onClick={() => {
              setVisible(true);
            }}
            key="signout"
          >
            <ListItemIcon>
              <img src={Signout} alt="Sign Out" />
            </ListItemIcon>
            <span className={`list-item `}>{t('SIGN_OUT')}</span>
          </ListItemButton>
        </List>
      </Paper>
    </Box>
  );
};

export const mapStateToProps = (state) => {
  return {
    countryCode: state.appStates.allContracts?.countryCode,
    oktaCountryCode: state.appStates.userDetailsInfo?.country,
    noScheduleData: state.appStates?.noScheduleData,
    contractCounts: state.appStates?.contractNumbers?.contractCounts,
    pastContractsCounts: state.appStates?.contractNumbers?.pastContractsCounts,
  };
};
export default connect(mapStateToProps)(Sidebar);
